export const mapExtraInfo = (leg, extras) => ({
  date: leg.timing.isoDate,
  departsAt: leg.timing.departs,
  arrivesAt: leg.timing.arrives,
  origin: leg.origin,
  destination: leg.destination,
  classOfService: leg.classOfService,
  trainNumber: leg.trainNumber,
  extras: extras.filter(
    (e) =>
      e.origin.uic === leg.origin.uic &&
      e.destination.uic === leg.destination.uic &&
      leg.activeBookingItems?.some((abi) => e.passengerId === abi.passengerId)
  )
});
